export default __webpack_public_path__ + "static/media/Verladung Porsche KS juli 2019 24_1.21024212.jpg";